import React, { Fragment, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, Link } from 'react-router-dom';

import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import useScrollReveal from '../../hooks/useScrollReveal';

import { findMember } from './leadershipData';
import Petals from './Petals';
import './aboutV2.css';

const scrollTop = () => window.scrollTo(0, 0);

const TeamMember = () => {
    const { slug } = useParams();
    const member = findMember(slug);

    const rootRef = useRef(null);
    useScrollReveal(rootRef);

    useEffect(() => {
        scrollTop();
    }, [slug]);

    if (!member) {
        return (
            <Fragment>
                <Helmet><title>Member not found | JJF India</title></Helmet>
                <div className="jjfv2 about-live">
                    <HeaderV2 />
                    <main className="page_content">
                        <AboutHero
                            eyebrow="Leadership Team"
                            title="Member not found"
                            crumbs={[
                                { label: 'Home', to: '/' },
                                { label: 'About Us', to: '/about-us/who-we-are' },
                                { label: 'Leadership Team', to: '/about-us/leadership-team' },
                                { label: 'Not found' },
                            ]}
                        />
                        <section className="section">
                            <div className="wrap">
                                <div className="about-prose about-prose--center">
                                    <p>Sorry, we couldn't find that team member.</p>
                                    <p>
                                        <Link className="btn btn--amber" to="/about-us/leadership-team" onClick={scrollTop}>
                                            Back to Leadership Team
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </section>
                    </main>
                    <FooterV2 />
                </div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />
                <title>{member.name} | JJF India</title>
                <meta name="description" content={member.bio} />
            </Helmet>

            <div className="jjfv2 about-live" ref={rootRef}>
                <HeaderV2 />

                <main className="page_content">
                    <AboutHero
                        eyebrow={member.role}
                        title={member.name}
                        crumbs={[
                            { label: 'Home', to: '/' },
                            { label: 'About Us', to: '/about-us/who-we-are' },
                            { label: 'Leadership Team', to: '/about-us/leadership-team' },
                            { label: member.name },
                        ]}
                    />

                    <section className="section lead-section">
                        {/* subtle falling petals / confetti backdrop */}
                        <Petals />

                        <div className="wrap">
                            <div className="member">
                                {/* photo */}
                                <div className="member__media reveal">
                                    <div className="member__photo">
                                        <img src={member.img} alt={member.name} />
                                    </div>
                                    {member.tag && <span className="member__badge">{member.tag}</span>}
                                </div>

                                {/* details */}
                                <div className="member__content reveal d1">
                                    <span className="eyebrow">{member.role}</span>
                                    <h2 className="member__name">{member.name}</h2>
                                    <p className="member__lead">{member.bio}</p>
                                    {member.about && member.about.map((p, i) => (
                                        <p className="member__para" key={i}>{p}</p>
                                    ))}

                                    {member.quote && (
                                        <blockquote className="member__quote">
                                            <p>&ldquo;{member.quote.text}&rdquo;</p>
                                            {member.quote.by && <cite>{member.quote.by}</cite>}
                                        </blockquote>
                                    )}

                                    <Link className="btn btn--amber member__back" to="/about-us/leadership-team" onClick={scrollTop}>
                                        ← Back to Leadership Team
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <FooterV2 />
            </div>
        </Fragment>
    );
};

export default TeamMember;
